import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VALIDATIONS, WIDGET_ACTIONS_VALIDATIONS } from '../../../../constants/proj.cnst';
import { VALIDATION } from '../../../../models/app-json';
import { WidgetPropertyFormService } from '../../widget-property-form.service';
import { isNullOrUndefined, PERMISSIONS_ACTIONS,APP_BUILDER_PERMISSIONS } from 'shared-library';

@Component({
  selector: 'lib-widget-validations',
  templateUrl: './widget-validations.component.html',
  styleUrl: './widget-validations.component.scss'
})
export class WidgetValidationsComponent implements OnInit,OnChanges {
  @Input() widget: any;
  @Input() applicationId: any;

  selectedValidationIndex: any;
  editMode: boolean = false;
  showValidationForm: boolean = false;
  isSelectedValidationType: boolean = false;
  isValidationExist: boolean = false;
  isLengthValidation: boolean = false;
  isDateValidation: boolean = false;
  isRegexValidation: boolean = false;
  isMessageValidation: boolean = false;
  isValid: boolean = true;
  validationForm!: FormGroup;
  inputFieldValidationData = ['Required', 'Minimum Length', 'Maximum Length', 'Regular Expression'];
  validationNames: typeof VALIDATIONS = VALIDATIONS;
  widgetActionsandValidations: any = WIDGET_ACTIONS_VALIDATIONS;

  validationValue!: string;
  regexPattern!: string;

  appPermissions = APP_BUILDER_PERMISSIONS;
  permissionsActions = PERMISSIONS_ACTIONS;

  constructor(private _formBuilder: FormBuilder, private widgetPropertyformService: WidgetPropertyFormService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initializeValidations();
  }

  ngOnInit(): void {
    this.formBuilder();
    this.initializeValidations();
  }

  initializeValidations() {
    this.inputFieldValidationData = [...this.widgetActionsandValidations[this.widget.widgetType].validation];
    let selectedValidationMap: any = [];
    let filterValidationData: any = [];
    if (this.widget?.widgetConfig?.validations) {
      this.widget?.widgetConfig?.validations?.length == this.widgetActionsandValidations[this.widget.widgetType]?.validation.length ? this.showValidationForm = false : this.showValidationForm = true;
      selectedValidationMap = this.widget?.widgetConfig?.validations.length > 0 ? this.widget?.widgetConfig?.validations.map((ele: any) => ele.validation_type) : [];
      filterValidationData = this.inputFieldValidationData.filter((ele: any) => !selectedValidationMap.includes(ele));
    } else {
      this.showValidationForm = true;
    }
    this.inputFieldValidationData = selectedValidationMap?.length > 0 ? filterValidationData : this.inputFieldValidationData;
  }

  formBuilder() {
    this.validationForm = this._formBuilder.group({
      selectedValidationType: [''],
      requiredMessage: [''],
      validationValue: ['', Validators.required],
      regexPattern: [''],
    })
  }

  getValidationValue(validation: string, value: any) {
    if (validation === 'Start Date' || validation === 'End Date') {
      const dt = new Date(value).toLocaleDateString()
      return dt;
    }
    else
      return value;
  }

  onSelectChange() {
    if (this.editMode) {
      this.validationForm.markAsDirty();
    }
    this.isSelectedValidationType = false;
    this.isValidationExist = false;
    this.isLengthValidation = false;
    this.isRegexValidation = false;
    this.isValid = true;
    if (this.validationForm.get('requiredMessage')?.value || this.validationForm.get('validationValue')?.value) {
      this.validationForm.get('requiredMessage')?.reset();
      this.validationForm.get('validationValue')?.reset();
      this.validationForm.updateValueAndValidity();
      this.isValid = true;
    }
    if (this.validationForm.get('selectedValidationType')?.value === 'Required') {
      this.isValid = false;
    }
  }

  onLengthAdd(event: any) {
    if (this.editMode) {
      this.validationForm.markAsDirty();
    }
    const selectedValidationType = this.validationForm.get('selectedValidationType')?.value;
    const inputValue = event.target.value;
    if(selectedValidationType ==='Required' && this.editMode){
      this.isValid = false; 
      this.isMessageValidation = false;
    }else{
      inputValue != '' ? (this.isValid = false) : (this.isValid = true);
      inputValue != '' ? (this.isMessageValidation = false) : (this.isMessageValidation = true);
      
    }
    if (selectedValidationType === 'Minimum Length' || selectedValidationType === 'Maximum Length') {
      this.validationForm.patchValue({ validationValue: event.target.value.replace(/[^\d]/g, '') });
      if (event.target.value === '') {
        this.isLengthValidation = false;
      } else if (this.widget?.widgetConfig?.validations?.length > 0) {
        let validationsList: any = this.widget.widgetConfig.validations;
        const maxLengthFindIndex = validationsList.findIndex((v: any) => v.validation_type === 'Maximum Length');
        const minLengthFindIndex = validationsList.findIndex((v: any) => v.validation_type === 'Minimum Length');
        const validationValue = Number(this.validationForm.get('validationValue')?.value);
        if (!/[\d]/.test(inputValue)) {
          this.isLengthValidation = false;
        } else if (selectedValidationType === 'Maximum Length' && minLengthFindIndex != -1) {
          const minValue = Number(validationsList[minLengthFindIndex]?.validation_value);
          validationValue > minValue ? (this.isLengthValidation = false) : (this.isLengthValidation = true);
        } else if (selectedValidationType === 'Minimum Length' && maxLengthFindIndex != -1) {
          const maxValue = Number(validationsList[maxLengthFindIndex]?.validation_value);
          validationValue < maxValue ? (this.isLengthValidation = false) : (this.isLengthValidation = true);
        }
      }
    }
  }

  addValidation() {
    let selectedValidation: string = this.validationForm.get('selectedValidationType')?.value;
    if (selectedValidation == null) {
      this.isSelectedValidationType = true;
    } else {
      let findIndex: number = this.inputFieldValidationData.findIndex((ele: any) => ele == selectedValidation);

      if (selectedValidation === 'Required') {
        if (!this.isMessageValidation || this.editMode) {
          const newValidation: VALIDATION = {
            validation_type: 'Required',
            validation_value: 'True',
            error_message: this.validationForm.get('requiredMessage')?.value,
            validation_key: 'req'
          };
          this.addOrUpdateValidation(newValidation);
          this.validationForm.get('selectedValidationType')?.reset();
          this.validationForm.get('requiredMessage')?.reset();
        }
      }
      else if (selectedValidation === 'Start Date' || selectedValidation === 'End Date') {
        this.validationValue = this.validationForm.get('validationValue')?.value;
        this.isMessageValidation = this.validationValue === '';
        if (!this.isLengthValidation && !this.isMessageValidation) {
          const newValidation: VALIDATION = {
            validation_type: selectedValidation,
            validation_value: this.validationValue,
            validation_key: selectedValidation != 'Start Date' ? 'eDate' : 'sDate'
          };
          this.addOrUpdateValidation(newValidation);
          this.validationForm.get('selectedValidationType')?.reset();
          this.validationForm.get('validationValue')?.setValue('');
        }
      } else if (selectedValidation === 'Regular Expression') {
        this.regexPattern = this.validationForm.get('regexPattern')?.value;
        this.isMessageValidation = this.regexPattern === '';

        if (!this.isRegexValidation && !this.isMessageValidation) {
          const newValidation: VALIDATION = {
            validation_type: selectedValidation,
            validation_value: this.regexPattern,
            error_message: this.validationForm.get('requiredMessage')?.value,
            validation_key: 'regex'
          };
          this.addOrUpdateValidation(newValidation);
          this.validationForm.reset();
        }
      }
      else {
        this.validationValue = this.validationForm.get('validationValue')?.value;
        this.isMessageValidation = this.validationValue === '';
        if (!this.isLengthValidation && !this.isMessageValidation) {
          const newValidation: VALIDATION = {
            validation_type: selectedValidation,
            validation_value: this.validationValue,
            validation_key: selectedValidation != 'Maximum Length' ? 'min' : 'max',
            error_message: this.validationForm.get('requiredMessage')?.value,
          };
          this.addOrUpdateValidation(newValidation);
          this.validationForm.get('selectedValidationType')?.reset();
          this.validationForm.get('validationValue')?.reset();
        }
      }
      if (!this.isMessageValidation || this.editMode) {
        this.inputFieldValidationData.includes(selectedValidation) ? this.inputFieldValidationData.splice(findIndex, 1) : '';
        this.inputFieldValidationData.length == 0 ? (this.showValidationForm = false) : '';
      }
    }
  }

  addOrUpdateValidation(newValidation: VALIDATION) {
    if (!this.widget.widgetConfig.validations) {
      this.widget.widgetConfig.validations = [];
    }
    const existingValidationIndex = this.widget.widgetConfig.validations.findIndex(
      (v: any) => v.validation_type === newValidation.validation_type
    );
    if (existingValidationIndex !== -1) {
      if (newValidation.validation_type == 'Required')
        this.widget.widgetConfig.validations[existingValidationIndex].error_message =
          newValidation.error_message;
      else
        this.widget.widgetConfig.validations[existingValidationIndex].validation_value =
          newValidation.validation_value;
      this.widget.widgetConfig.validations[existingValidationIndex].error_message =
        newValidation.error_message;
    } else {
      this.widget.widgetConfig.validations = [
        ...this.widget.widgetConfig.validations,
        newValidation,
      ];
    }
    this.widgetPropertyformService.updateValidation(this.widget, this.applicationId);
    this.validationForm.get('selectedValidationType')?.enable();
    this.editMode = false;
  }



  deleteValidation(index: number) {
    this.showValidationForm = true;
    let validationType: any = this.widget.widgetConfig.validations[index]['validation_type'];
    this.inputFieldValidationData.includes(validationType) ? "" : this.inputFieldValidationData.push(validationType);
    if (this.widget && this.widget.widgetConfig.validations && this.widget.widgetConfig.validations.length > 0) {
      this.widget.widgetConfig.validations.splice(index, 1);
      this.widgetPropertyformService.updateValidation(this.widget, this.applicationId);
    }
    if (validationType === 'Maximum Length' || validationType === 'Minimum Length' || validationType === 'Start Date' || validationType === 'End Date') {
      this.isSelectedValidationType = false;
      this.isValidationExist = false;
      this.isLengthValidation = false;
      this.isDateValidation = false;
      this.isValid = false;
    }
  }



  editValidations(validation: any) {
    this.validationForm.reset();
    this.editMode = true;
    this.validationForm.get('selectedValidationType')?.disable();
    this.validationForm.markAsPristine();
    this.showValidationForm = true;
    this.selectedValidationIndex = this.widget.widgetConfig.validations.indexOf(validation);
    if (!this.inputFieldValidationData.includes(validation.validation_type)) {
      this.inputFieldValidationData.push(validation.validation_type);
    }
  
    if (validation.validation_type === 'Required') {
      this.validationForm.patchValue({
        selectedValidationType: validation.validation_type,
        requiredMessage: validation.error_message ?? '', 
        validationValue: validation.validation_value
      });
      this.isValid = false; 
      this.isMessageValidation = false; 
    } else if (validation.validation_type === 'Start Date' || validation.validation_type === 'End Date') {
      this.validationForm.patchValue({
        selectedValidationType: validation.validation_type,
        validationValue: validation.validation_value
      });
    } else if (validation.validation_type === 'Regular Expression') {
      this.validationForm.patchValue({
        selectedValidationType: validation.validation_type,
        regexPattern: validation.validation_value,
        requiredMessage: validation.error_message ?? ''
      });
    } else {
      this.validationForm.patchValue({
        selectedValidationType: validation.validation_type,
        validationValue: validation.validation_value,
        requiredMessage: validation.error_message ?? ''
      });
    }
  }

  /**
  checks whether the given validation matches the selected validation
 */
  checkValidationMatched(value: string) {
    return this.validationForm.get('selectedValidationType')?.value === value;
  }


  onDateChange(event: any) {
    if (this.editMode) {
      this.validationForm.markAsDirty();
    }
    let validationsList: any = this.widget.widgetConfig.validations;
    if (!isNullOrUndefined(validationsList)) {
      const startDateindIndex: any = validationsList.findIndex((v: any) => v.validation_type === 'Start Date');
      const endDateFindIndex: any = validationsList.findIndex((v: any) => v.validation_type === 'End Date');
      const validationValue = new Date(this.validationForm.get('validationValue')?.value);

      if (this.validationForm.get('selectedValidationType')?.value === 'Start Date' && endDateFindIndex != -1) {
        const minValue = new Date(validationsList[endDateFindIndex]?.validation_value);
        validationValue > minValue ? this.isDateValidation = true : this.isDateValidation = false;
      } else if (this.validationForm.get('selectedValidationType')?.value === 'End Date' && startDateindIndex != -1) {
        const maxValue = new Date(validationsList[startDateindIndex]?.validation_value);
        validationValue < maxValue ? this.isDateValidation = true : this.isDateValidation = false;
      }
    }
    event.target.value != '' ? this.isValid = false : this.isValid = true;
    event.target.value != '' ? this.isMessageValidation = false : this.isMessageValidation = true;
  }


  validateRegex(event: Event) {
    const regexPattern = this.validationForm.get('regexPattern')?.value;
    if (this.editMode) {
      this.validationForm.markAsDirty();
    }
    this.isValid = regexPattern == '';
    try {
      new RegExp(regexPattern);
      this.isRegexValidation = false;
      this.validationForm.get('regexPattern')?.setErrors(null);
    } catch (error) {
      this.isRegexValidation = true;
      this.validationForm.get('regexPattern')?.setErrors({ invalidRegex: true });
    }
  }

}
